import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  templateUrl: './index.component.html',
  styleUrls: ['../docs.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class IndexPage {}
